import { IInitialState } from 'Container/App/interface';
import {
    ADDITIONAL_PAGE_OPTIONS,
    SALESCHANNEL_CONSUMER,
} from '@vfde-sails/constants';
import { getHardwareOnly } from 'Container/App/helpers/getHardwareOnly';
import { getPaymentMethod } from 'Container/App/helpers/getPaymentMethod';
import { getAtomicId } from 'Container/App/helpers/getAtomicId';

const getCustomerConfig = (): NonNullable<IInitialState['customerConfig']> => {
    const deviceId = window[ADDITIONAL_PAGE_OPTIONS].deviceId;
    const isHardwareOnly = getHardwareOnly();
    const paymentMethod = getPaymentMethod();

    return {
        salesChannel: SALESCHANNEL_CONSUMER,
        atomicId: getAtomicId(),
        deviceId,
        isHardwareOnly,
        paymentMethod,
    };
};

export default getCustomerConfig;
